import React from 'react';
import { Dropdown } from 'antd';
import { StyledIcon } from '@/shared/styles';
import { calendarIcon } from '@/assets/images/icons';
import { Datepicker } from './Datepicker';
import { StyledNoStyleButton } from './Datepicker.styles';
import { useDatepickerRangeStore } from '@/stores/DatepickerRangeStore/DatepickerRangeStore';
import { DatepickerRangeTriggerProps, DatepickerType } from './Datepicker.consts';
import { useTranslation } from 'react-i18next';

export const DatepickerRangeTrigger: React.FC<DatepickerRangeTriggerProps> = ({
  onSelect,
}: DatepickerRangeTriggerProps) => {
  const { isOpen, setIsOpen } = useDatepickerRangeStore();
  const { t } = useTranslation();

  return (
    <Dropdown
      open={isOpen}
      onOpenChange={setIsOpen}
      dropdownRender={() => <Datepicker type={DatepickerType.RANGE} onRangeSelect={onSelect} />}
      placement="bottomLeft"
      trigger={['click']}
      overlayClassName="datepicker"
      getPopupContainer={() => document.querySelector('.App') as HTMLElement}
    >
      <StyledNoStyleButton
        className="datepicker-trigger"
        aria-label={t('admin.datepicker.select_range')}
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
      >
        <StyledIcon src={calendarIcon} />
      </StyledNoStyleButton>
    </Dropdown>
  );
};
